import {
  Button,
  Divider,
  InformationCard,
  Text,
  useIsMobile
} from '@yes.technology/react-toolkit'
import { IDetectedBarcode } from '@yudiel/react-qr-scanner'
import { useState } from 'react'
import { useTranslation } from 'react-i18n-lite'
import qrcode from './assets/qrcode.png'
import QrCodeScanner from './QrCodeScanner'
import { Container } from './QrCodeScannerModal.styles'

type QrCodeScannerModalProps = {
  onClose: () => void
  isOpen: boolean
  onScanSuccess: (code: string) => void
}

const QrCodeScannerModal = ({
  isOpen,
  onClose,
  onScanSuccess
}: QrCodeScannerModalProps) => {
  const { t } = useTranslation()
  const [view, setMode] = useState<'info' | 'scanner'>('info')

  const onScan = (detectedCodes: IDetectedBarcode[]) => {
    if (detectedCodes.length > 0) {
      const [code] = detectedCodes
      if (code.rawValue) {
        onScanSuccess(code.rawValue)

        setMode('info')
      }
    }
  }

  const isMobile = useIsMobile()

  const getWidth = () => {
    if (view === 'info') {
      return isMobile ? '100%' : '334px'
    }

    if (isMobile) {
      return '100vw'
    }

    return '600px'
  }

  const getHeight = () => {
    if (view === 'info') {
      return 'auto'
    }

    if (isMobile) {
      return '100vh'
    }

    return 'auto'
  }

  const width = getWidth()

  const height = getHeight()

  const handleOnClose = () => {
    setMode('info')

    onClose()
  }

  return (
    <InformationCard
      isOpen={isOpen}
      title={''}
      close={handleOnClose}
      style={{
        width: '100%',
        height,
        maxWidth: width,
        padding: '2rem 1rem'
      }}
      hideHeader={view === 'info'}
    >
      {view === 'info' && (
        <Container>
          <Text variant='label-required-04'>
            {t('qr-code-reader.read-qr-code')}
          </Text>
          <Text variant='bordertext-emphasis-05'>
            {t('qr-code-reader.scan-qr-code')}
          </Text>
          <Divider color='gray' style={{ margin: 0 }} />
          <Text variant='label-required-02'>
            {t('qr-code-reader.camera-redirect')}
          </Text>
          <Text variant='label-02'>{t('qr-code-reader.center-camera')}</Text>
          <img src={qrcode} alt={t('qr-code-reader.read-qr-code')} />
          <Button onClick={() => setMode('scanner')}>
            {t('qr-code-reader.continue')}
          </Button>
          <Button onClick={handleOnClose} variant='secondary'>
            {t('qr-code-reader.cancel')}
          </Button>
        </Container>
      )}
      {view === 'scanner' && <QrCodeScanner onScan={onScan} />}
    </InformationCard>
  )
}

export default QrCodeScannerModal
